import { t } from "@lingui/macro";
import * as v from "valibot";
import type { Permission } from "~/models/permission";

export const key = "fanzone.post.create";

export const permissions: Array<Permission | RegExp> = [
  "Fanzone.FeedAddSocialPost",
];

export const Schema = () =>
  v.object({
    artistUid: v.pipe(
      v.string(t`The artist ID is required.`),
      v.minLength(1, t`The artist ID is required.`),
    ),
    labelUid: v.pipe(
      v.string(t`The label ID is required.`),
      v.minLength(1, t`The label ID is required.`),
    ),
    tierUid: v.optional(v.string()),
  });
